import { Injectable } from '@angular/core';
import { IManagementGroup, IResponse } from '@interfaces/index';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementGroupService {

  constructor(
    private http_service: HttpService,
  ) { }

  getManagementGroupsForAdmin(): Observable<IResponse<IManagementGroup[]>> {
    return this.http_service.post<IManagementGroup[]>('auth/management-groups', {});
  }
}
